import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import {httpClient} from "../../core/HttpClient";
import Alert from "@mui/material/Alert";
import {useTranslation} from "react-i18next";

export default function WebsitePage(props) {
    const { cid } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    console.log('WebsitePage');
    const { t } = useTranslation();

    useEffect(() => {
        console.log('[WebsitePage]', cid);
        try {

            const url = process.env.REACT_APP_API_BASE_URL + '/publish/account';
            httpClient.get(url)
                .then(res => {
                    if(res.data){
                        let websiteUrl = res.data.website;
                        if(websiteUrl){
                            window.location.href = websiteUrl;
                        }
                    } else {

                    }
                    setLoading(false);
                }).catch(e=>{
                console.log('error', e);
                setLoading(false);
            });


        } catch (e){
            console.log(e);
        }
    }, [history, props, cid]);

    return (
        <div>
            {loading &&
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress size={20}/>
                </Box>
            }
            {!loading &&
                <Box p={2}>
                    <Alert severity="info" style={{borderRadius: 0}} >{t('shop.websiteNotFound')}</Alert>
                </Box>
            }
        </div>
    );
}
